import type { Profile } from '@vgtv/api-client/lib/cnp_tag';
import type { ProfilesState } from './index';

type State = { profiles: ProfilesState };

export const selectProfiles = (state: State) => state.profiles;

export const selectProfileById = (state: State, profileId: Profile['id']) =>
  profileId ? state.profiles[profileId] : undefined;
